import { render, staticRenderFns } from "./GDPRErase.vue?vue&type=template&id=1e7479b6&"
import script from "./GDPRErase.vue?vue&type=script&lang=js&"
export * from "./GDPRErase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports